<template>
  <div class="row">
    <div class="card col-8">
      <div class="card-header">
        <h4>{{ $t('container.self') }}</h4>
      </div>
      <div class="card-body">
        <a-form-model
          ref="container-form"
          :rules="rules"
          :model="form"
          v-bind="layout"
        >
          <a-form-model-item
            :label="$t('container.self')"
            prop="name"
            has-feedback
          >
            <a-input
              v-model="form.name"
            />
          </a-form-model-item>
          <a-form-model-item
            :label="$t('container.weight')"
          >
            <div
              class="location-wrapper"
            >
              <a-form-model-item
                :label="$t('common.from')"
                prop="from"
                :label-col="{span: 8}"
                :wrapper-col="{span: 16}"
                has-feedback
              >
                <a-input-number
                  v-model="form.from"
                  :min="0"
                />
              </a-form-model-item>
              <a-form-model-item
                :label="$t('common.to')"
                prop="to"
                :label-col="{span: 8}"
                :wrapper-col="{span: 16}"
                has-feedback
              >
                <a-input-number
                  v-model="form.to"
                  :min="0"
                />
              </a-form-model-item>
            </div>
            <a-form-model-item>
              <a-button
                type="primary"
                @click="submitForm('container-form')"
              >
                {{ id ? $t('common.save') : $t('common.send') }}
              </a-button>
            </a-form-model-item>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerService from '@/services/api/admin/library/container-service'

export default {
  name: 'Container',
  data() {
    return {
      id: this.$route.params.id === 'new' ? null : this.$route.params.id,
      loading: false,
      form: {
        name: '',
        from: null,
        to: null,
      },
      layout: {
        labelCol: { span: 9 },
        wrapperCol: { span: 15 },
      },
      majorBranches: [],
    }
  },

  computed: {
    rules() {
      return {
        name: [{
          validator: this.validateString,
          trigger: 'change',
        }],
        from: [{
          validator: this.validateWeightFrom,
          trigger: 'change',
        }],
        to: [{
          validator: this.validateWeightTo,
          trigger: 'change',
        }],
      }
    },
  },

  mounted() {
    if (this.id) {
      this.getContainer()
    }
  },

  methods: {
    getContainer() {
      this.loading = true
      ContainerService.getContainer(this.id)
        .then(response => {
          const content = response.data.content
          this.form = {
            name: content.name,
            from: content.from,
            to: content.to,
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    validateString(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error(this.$t('common.required')))
      } else {
        callback()
      }
    },

    validateWeightFrom(rule, value, callback) {
      if (value === null) {
        callback(new Error(this.$t('common.required')))
      } else if (value > this.form.to) {
        callback(new Error(this.$t('container.wrong_weight')))
      } else {
        callback()
      }
    },

    validateWeightTo(rule, value, callback) {
      if (value === null) {
        callback(new Error(this.$t('common.required')))
      } else if (value < this.form.from) {
        callback(new Error(this.$t('container.wrong_weight')))
      } else {
        callback()
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const body = this.form
          if (this.id) {
            this.loading = true
            ContainerService.updateContainer(this.id, body)
              .then(() => {
                this.$message.success(this.$t('common.saved'))
                this.$router.push('/admin/library/containers')
              })
              .catch(() => {
                this.$message.error(this.$t('common.error'))
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            this.loading = true
            ContainerService.createContainer(body)
              .then(() => {
                this.$message.success(this.$t('common.success'))
                this.$router.push('/admin/library/containers')
              })
              .catch(() => {
                this.$message.error(this.$t('common.error'))
              })
              .finally(() => {
                this.loading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.location-wrapper {
  display: flex;
  justify-content: space-evenly;
}

.work-time-wrapper {
  display: flex;
  justify-content: start;
}
</style>
